export enum FeatureFlag {
  DEMO = 'demo',
  DEMO_DATA_FOUNDATION = 'demoDataFoundation',
  EMISSIONS = 'emissions',
  ENABLE_CATALOG_PUNCHOUT_LINKS = 'enableCatalogPunchoutLinks',
  ENABLE_ENBW_SMART_SCALE_AGENT = 'enableEnBWSmartScaleAgent',
  ENABLE_NEGOTIATION_OBJECTIVE = 'enableNegotiationObjective',
  FILE_SHARING = 'fileSharing',
  INTAKE = 'intake',
  RISK_SUSTAINABILITY = 'riskSustainability',
  SHOW_AGENT_COMPLIANCE = 'showAgentCompliance',
  SHOW_AGENT_FRONTDESK = 'showAgentFrontdesk',
  SHOW_DELIVERY_LOCATION = 'showDeliveryLocation',
  SHOW_ORGANIZATION = 'showOrganization',
  SMART_LINKS = 'smartLinks',
  INTAKE_FLOW_SOW = 'intakeFlowSoW',
  HIDE_SKIP_UPLOAD_QUOTE_BUTTON = 'hideSkipUploadQuoteButton',
  SHOW_NEW_AWARDING_CONFIGURATION_WIDGET = 'showNewAwardingConfigurationWidget',
  AWARDABLE_CONFIRMED_QUOTES = 'awardableConfirmedQuotes',
  NEW_FILE_ATTACHMENTS_WIDGET = 'newFileAttachmentsWidget',
  ENABLE_NEGOTIATION_QUOTE_LINE_ITEM_BIDDING = 'enableNegotiationQuoteLineItemBidding',
  SHOW_DEMAND_CONVERSATION_QUICK_ACTIONS = 'showDemandConversationQuickActions',
  ENABLE_MATERIAL_SEARCH = 'enableMaterialSearch',
  SCOPE_SWITCHER = 'scopeSwitcher',
  OPTIONAL_QUOTED_SUPPLIER_CONTACT_LOCATION = 'optionalQuotedSupplierContactLocation',
}

type FeatureFlagType = `${FeatureFlag}`;
type FeatureFlagFields = { [K in FeatureFlagType]: boolean };
declare module '@procureai/permissions-ui' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface FeatureFlags extends FeatureFlagFields {}
}
